module.exports = {
  // 顶部导航
  Header: {
    bookcount: "",
    bookcount2: " books in total",
    lookcount: "Website Views",
    homePage: "Home page",
    bookList: "My book list",
    record: "Book selection record",
    userManual:"User Manual",
    logOut: "Log out",
  },
  // 首页标语
  slogan: "Innovation, integrity, service and realism",
  // 首页表单
  SearchBoxForm: {
    keyword: "keyword",
    isbn: "ISBN",
    pubyear: "pubyear",
    pub: "press",
    title: "title",
    searchTips: "Please enter the retrieval content",
    search: "Search",
    coRetrieval: "Click Search by Category (total retrieved",
    coRetrieval2: " books retrieved)",
    coRetrieval3: "",
    coRetrieval4: " books retrieved",
    exportSearchBook:"Download",
  },
  // 列表项组件
  BookItem: {
    ISBN: "ISBN",
    Binding: "Binding",
    pages: "pages",
    Price: "Price",
    SupplyStatus: "SupplyStatus",
    add: "Add Book List",
  },
  // 二级树组件
  TreeBoxTip: "Search by category:",
  // 提示信息
  PromptInfo: {
    emptyContent: "The input content is empty, please check!",
    message:
      "Dear users, it is recommended to place the screen horizontally when using mobile devices for a better reading experience.",
    Warn: "Warn",
    logoutText: "After logging out will be",
    logoutText2: "remove completely",
    logoutText3:
      "The book information in My Book List, please be sure to export and backup the book list before logging out.",
  },
  // 书单相关提示信息
  BooklistInfo: {
    okText: "confirm",
    cancelText: "cancel",
    AppendTitle: "Continue appending?",
    AppendInfo: 'It is detected that there are one or more "',
    AppendInfo2: '" in the book list. Do you want to continue to add it?',
    AppendInfo3: '"',
    AppendInfo4: '" has been added to my book list.',
    AppendInfo5: 'Give up adding "',
    AppendInfo6: '"',
    AppendInfo7: '" removed from my book list.',
  },
  // 图书详情
  details: {
    Category: "Category:",
    Publisher: "Publisher: ",
    Binding: "Binding: ",
    Pages: "Pages: ",
    CLCNumber: "CLCNumber: ",
    ISBN: "ISBN: ",
    Availability: "Availability: ",
    Price: "Price: ",
    add: "Add to my list +",
    IntroductionInfo: "Introduction to the book",
    AwardInfo: "Award information",
    CollectionInfo: "Collection information",
    None: "None",
  },
  // 我的书单
  bookList: {
    Details: "Details",
    Delete: "delete",
    Export: "Export",
    Excel: "Export book list to local (Excel table)",
    Upload: "Upload my book selection list",
    Upload2: "Upload book list",
    Name: "Name",
    Name2: "Please type in your name",
    Telephone: "Telephone",
    Telephone2: "Please enter a number",
    Telephone3: "Please enter the correct mobile/landline number",
    Telephone4: "Please enter a mobile/landline number",
    Mail: "Mail",
    Mail2: "please input your email",
    Mail3: "The email format is incorrect, please check!",
    Faculty: "Faculty",
    Faculty2: "Please enter department",
    Type: "type of jobs",
    Type2: "Please choose the type",
    Student: "student ID",
    Student2: "Please enter student number",
    Reason: "Recommended reason",
    Reason2: "Please enter the reason for recommendation",
    Reason3: "Recommendation/Purchase Reason",
    Submit: "Submit book list",
    Submit2: "The book list has been successfully submitted to the cloud!",
    Submit3: "The book list is empty, the book list cannot be uploaded!",
  },
  //图片上传界面
  uploadImage:{
    Name:"name",
    Department:"School/Department",
    UserID:"UserID",
    PatronType:"PatronType",
    Faculty:"Faculty",
    BookImage:"BookImage",
    NameOption:"Please enter your name",
    DepartmentOption:"Please enter your school/department",
    UserIDOption:"Please enter your userid",
    PatronTypeOption:"Please enter your patron type",
    FacultyOption:"Please enter your patron faculty",
    BookImageOption:"Please upload photos of the books you recommend.",
    SubmitBtn:"Submit"
  },
    //身份类型
    types:{
      Teacher: "Teacher" ,
      Student: "Student",
      Administrators:"Administrators",
      Research: "Research",
      Others: "Others" ,
    },
  // 表格
  table: {
    Cover: "Cover",
    BookTitle: "BookTitle",
    Author: "Author",
    PublishingHouse: "PublishingHouse",
    Category: "Category",
    ISBN: "ISBN",
    CLCnumber: "CLCnumber",
    Framing: "Framing",
    Pages: "Pages",
    Currency: "Currency",
    Price: "Price",
    Availability: "Availability",
    Operate: "Operate",
    NumberOfResults: "Result:",
    TheTotalNumberOfSelectedBooks: "Total:",
    ExportAllRecords:"Export all records"
  },
  // 404页面
  404: {
    title: "Life is always a little ridiculous, you say.",
    BackToHome: "Back to Home",
  },
  // 页脚
  footer: {
    Copywriting: "Free online book exhibition since 2022",
    officialWeb: "Company official website",
    copyright: "© ctibooks",
    beian1: "Jing ICP Bei No. 06062204 Jing",
    baian2: "Public Network Anbei No. 11010802039466",
  },
};
